import React, { ReactElement, useContext } from 'react';
import { useAddActionDialogForContenxt } from '@act/react-components/dialog-forms/hooks/useAddActionDialog.hook';
import { useAddressDialogForContext } from 'react-components/dialog-forms/hooks/useAddressDialog.hook';
import { useChangeLogDialogForContext } from 'react-components/dialog-forms/hooks/useChangeLogDialog.hook';
import { useConfirmationAlertDialogForContext } from 'react-components/dialog-forms/hooks/useConfirmationAlertDialog.hook';
import { useCreateNeedFormDialogForContext } from 'react-components/dialog-forms/hooks/useCreateNeedFormDialog.hook';
import { useEmailAddressDialogForContext } from 'react-components/dialog-forms/hooks/useEmailAddressDialog.hook';
import { useFulfillNeedDialogForContext } from 'react-components/dialog-forms/hooks/useFulfillNeedDialog.hook';
import { useLinkConsentsDialogForContext } from 'react-components/dialog-forms/hooks/useLinkConsentsDialog.hook';
import { useMemberStatusChangeRequestDialogForContext } from 'react-components/dialog-forms/hooks/useMemberStatusChangeRequestDialog.hook';
import { useMemberSummaryFeedbackDialogForContext } from 'react-components/dialog-forms/hooks/useMemberSummaryFeedbackDialog.hook';
import { usePersonalInformationDialogForContext } from 'react-components/dialog-forms/hooks/usePersonalInformationDialog.hook';
import { usePhoneNumberDialogForContext } from 'react-components/dialog-forms/hooks/usePhoneNumberDialog.hook';
import { useRichMessageDialogForContext } from 'react-components/dialog-forms/hooks/useRichMessageDialog.hook';
import { useTermConsentsDialogForContext } from 'react-components/dialog-forms/hooks/useTermConsentsDialog.hook';
import { useTextConsentsDialogForContext } from 'react-components/dialog-forms/hooks/useTextConsentsDialog.hook';
import { useTransferRequestDialogForContext } from 'react-components/dialog-forms/hooks/useTransferRequestDialog.hook';
import { useViewConsentsHistoryDialogForContenxt } from 'react-components/dialog-forms/hooks/useViewConsentsHistoryDialog.hook';
import { useAssignPhoneCallDialogForContext } from '@act/react-components/form-dialog/hooks/useAssignPhoneCallDialog.hook';
import { useAssignPhoneNumberDialogForContext } from '@act/react-components/form-dialog/hooks/useAssignPhoneNumberDialog.hook';
import { useAssignTextMessageDialogForContext } from '@act/react-components/form-dialog/hooks/useAssignTextMessageDialog.hook';
import { useMessageDialogForContext } from 'react-components/form-dialog/hooks/useMessageDialog.hook';
import { useAssignCallAuditorDialogForContext } from '@act/react-components/form-dialog/hooks/useAssignCallAuditorDialog.hook';
import { useLearnMoreDialogForContext } from 'react-components/dialog-forms/hooks/useLearnMoreDialog.hook';
import { useAssignedSurveyDialogForContext } from '@act/react-components/dialog-forms/hooks/useAssignedSurveyDialog.hook';
import { useHospitalizationDialogForContext } from 'react-components/dialog-forms/hooks/useHospitalizationsDialog.hook';

const dialogHooks: (() => {
  component: ReactElement;
  metadata: { [key: string]: unknown };
})[] = [
  useAddActionDialogForContenxt,
  useAddressDialogForContext,
  useAssignPhoneCallDialogForContext,
  useAssignPhoneNumberDialogForContext,
  useAssignTextMessageDialogForContext,
  useMessageDialogForContext,
  useAssignCallAuditorDialogForContext,
  useChangeLogDialogForContext,
  useConfirmationAlertDialogForContext,
  useCreateNeedFormDialogForContext,
  useEmailAddressDialogForContext,
  usePersonalInformationDialogForContext,
  usePhoneNumberDialogForContext,
  useRichMessageDialogForContext,
  useTransferRequestDialogForContext,
  useMemberSummaryFeedbackDialogForContext,
  useMemberStatusChangeRequestDialogForContext,
  useFulfillNeedDialogForContext,
  useTextConsentsDialogForContext,
  useLinkConsentsDialogForContext,
  useTermConsentsDialogForContext,
  useViewConsentsHistoryDialogForContenxt,
  useLearnMoreDialogForContext,
  useAssignedSurveyDialogForContext,
  useHospitalizationDialogForContext,
];

export const DialogContext = React.createContext<{ [key: string]: unknown }>(
  {}
);
export const useDialogContext = () => useContext(DialogContext);

export const DialogProvider = (props: { children }) => {
  const components: ReactElement[] = [];
  let metadata: { [key: string]: unknown } = {};
  for (const useHook of dialogHooks) {
    const { component: hookComponent, metadata: hookMetadata } = useHook();
    components.push(hookComponent);
    metadata = { ...metadata, ...hookMetadata };
  }
  return (
    <DialogContext.Provider value={metadata}>
      {components}
      {props.children}
    </DialogContext.Provider>
  );
};
